// extracted by mini-css-extract-plugin
export default {"video-render":"VideoRender_video-render__T2bTY"};